<template>
  <v-container class="mt-12 pt-8" style="background:#fafafa;">
    <v-row style="background:#fafafa;">
      <v-col cols="12" class="pa-0">
        <v-row class="pa-0 px-6">
          <v-col cols="12" FLAG-COUNTRY-PICKER>
            <v-row class="px-5 text-center">
              <v-col cols="12" :class="`${arabic?'arFont':'enFont'} pa-5 text-center`" style="font-size:22px;">
                {{ i18n['pick_a_country'] }}
              </v-col>
              <v-item-group v-model="selectedCountryId" class="text-center" dense>
                <v-item
                  v-for="(country, c) in countries" :key="'country-' +c"
                  v-slot="{ active, toggle }"
                  class="text-center"
                >
                  <v-btn 
                    active-class="biggerPix"
                    :input-value="active"
                    label 
                    class="flagBtn ma-1"
                    @click="toggle"
                    link
                    :loading="loading"
                    text
                    :value="country"
                    style="text-transform:uppercase;" 
                    :disabled="soon(country.alpha2Code.toLowerCase())"
                    dark 
                    color="primary">
                    <v-badge
                      bordered
                      overlap
                      tile
                    >
                    <template v-slot:badge>
                      <div v-if="soon(country.alpha2Code.toLowerCase())" :class="`${arabic ? 'arFont' : 'enFont'}`"> {{ i18n['soon'] }} </div>
                    </template>
                      <img width="53px" style="filter:drop-shadow(2px 2px 4px rgb(0 0 0 / 38%));" :src="`/flags/${country.alpha2Code.toLowerCase()}.png`" alt="">
                    </v-badge>
                      <span :class="`${arabic ? 'arFont' : 'enFont'} primary--text`">{{ countries_[language][country.alpha2Code.toLowerCase()] }}</span>
                  </v-btn>
                </v-item>
              </v-item-group>
              <v-col cols="1" class="pa-2" v-for="(country, c) in 0" :key="'country-' +c">
                <img width="100%" style="filter:drop-shadow(2px 2px 4px rgb(0 0 0 / 38%));" :src="`/flags/${country.alpha2Code.toLowerCase()}.png`" alt="">
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} text-center pa-2`">
            {{ search_term }}
            <v-text-field
              label="Search"
              dense
              filled
              v-model="search"
              clearable
              @keypress.enter="fireSearch()"
              hide-details
            >
              <template v-slot:append>
                <v-tooltip
                  bottom
                >
                  <template v-slot:activator="{ on }">
                    <v-btn small :loading="loading" color="primary" v-on="on" @click="fireSearch()">
                      <v-icon>
                        search
                      </v-icon>
                    </v-btn>
                  </template>
                  <span :class="`${arabic?'arFont':'enFont'}`">{{ i18n['search'] }}</span>
                </v-tooltip>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" md="2" class="text-center pa-2">
          </v-col>
          <v-col cols="12" md="8" class="text-center pa-2">
            <Paging 
              :resourceSettings="resourceSettings" 
              :resource="resource"
              @loadResource="loadResource"
              @pageByNumber="pageByNumber"
            />
          </v-col>
          <v-col cols="12" md="2" class="text-center pa-2">
            <v-progress-circular v-if="loading" color="primary" :indeterminate="true"></v-progress-circular>
          </v-col>
          <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} text-center pa-2 py-10 my-5`" style="font-size:22px;" v-if="products.length < 1">
            <v-icon size="50" class="my-5" color="grey lighten-2">sentiment_very_dissatisfied</v-icon>
            <div :class="`${arabic?'arFont':'enFont'} text-center my-5`">
              {{ i18n['no_results_please_try_again'] }}
            </div>
          </v-col>
          <v-col cols="12" md="3" v-for="(product, i) in products" :key="'product-'+i" class="pa-1">
            <Product :loading="loading" :i="i" :product="product" @reload="loadResource" />
          </v-col>
          <v-col cols="12" md="2" class="text-center pa-2">
          </v-col>
          <v-col cols="12" md="8" class="text-center pa-2">
            <Paging 
              :resourceSettings="resourceSettings" 
              :resource="resource"
              @loadResource="loadResource"
              @pageByNumber="pageByNumber"
            />
          </v-col>
          
          <v-col cols="12" md="2" class="text-center pa-2">
            <v-progress-circular v-if="loading" color="primary" :indeterminate="true"></v-progress-circular>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Product from '@/components/Product'
import dashboardSlider from '@/components/dashboardSlider'
import Paging from '@/components/Paging'
import ChangeCountry from '@/components/ChangeCountry'
import axios from 'axios';
const headers = {'Accept': 'application/json'};

export default {
  components: {Product, Paging, ChangeCountry, dashboardSlider},
  data() {
    return {
      loading:false,
      dialog:false,
      vresource:[],
      search:null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys:[
        
      ],
      resourceSettings:{
        resourceName:null,
        search:false,
        create:false,
        pagination:true,
      },
      newResource:{},
      editing:false,
      deleting:false,
      firstPanel:true,
      secondPanel:false,
      thirdPanel:false,
      selectedPanel:'firstPanel',
      subitems:[
        {
          text:'اضافة طلب جديد',
          icon:'add_shopping_cart',
          value:'firstPanel'
        },
        {
          text:'التوصل مع الدعم',
          icon:'support_agent',
          value:'secondPanel'
        },
      ],
      menu1:false,
      fromDate:null,
      menu2:false,
      toDate:null,
      statuses:[],
      selectedStatus:null,
      selectedCountry:null,
      selectedCategory:[],
      selectedCountryId:0,
      page:1,
      images:[
        {url:'/arjobanner.gif'},
        {url:'/arjobanner.gif'},
        {url:'/arjobanner.gif'},
      ],
      
      search:null,
    }
  },
  methods: {
    soon(str) {
      return this.soon_countries.includes(str)
    },
    async fireSearch(){
      this.$store.state.search = this.search
      this.$store.dispatch('searchResource', {page:`/${this.user.account.id}?page=1`})
    },
    async manualCountry() {
      this.loading = true
      localStorage.country = JSON.stringify(this.selectedCountry)
      this.$store.state.country = this.selectedCountry
      await this.$store.dispatch('manualCountry', this.selectedCountry)
      this.loading = false
    },
    countryDialog(){
      this.$store.state.country_dialog = false
    },
    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter(x=>typeof x == 'string')
      let a = false
      v.forEach(x=>{
        if(x.toLowerCase().includes(queryText.toLowerCase())) a = true
      })
      if(itemText && typeof itemText == 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true
      return a
    },
    clipboardSuccessHandler (){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler () {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    async pageByNumber(n){
      return new Promise(async (res, rej)=>{
        this.loading = true
        this.page = n
        await this.$store.dispatch('searchResource', {page:`/${this.user.account.id}?page=${n}`})
        this.loading = false
      })
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    buildFilter(){
      let filter = ``
      // console.log(this.selectedCategory)
      if(this.selectedCategory.length) {
        filter += `&filter[category]=${this.cat}`
      }
      return filter
    },
    async filterResources(){
      await this.loadResource()
    },
    firstLoad(){
      if(this.user) {
      }
    },
    async loadResource() {
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          // console.log(this.page, this.cat)
          this.resource = await this.$store.dispatch('load_products', {page:`/${this.cat}/${this.user.account.id}?page=${this.page}` + this.buildFilter()})
          // console.log(this.resource)
        } else {
          this.resource = await this.$store.dispatch('searchProducts', {resource:this.$route.path + '/search', value:this.search})
        }
        this.loading = false
        res()
      })
    },
    filterResources() {
      this.loadResource()
    },
    showPannel(v){
      this[v] = true
      let all = this.subitems.map(x=>x.value)
      all.filter(x=>x!=v).forEach(x=>this[x] = false)
    },
    setResourceName(){
      this.resourceSettings.resourceName = this.i18n[this.$route.path.replace('/', '')]
    }
  },
  computed:{
    soon_countries() {
      return this.$store.state.soon_countries
    },
    countries_() {
      return this.$store.state.countries_
    },
    products(){
      return this.$store.state.products
    },
    resource(){
      return this.$store.state.search_resource
    },
    search_term() {
      return this.$route.params.search
    },
    cat() {
      return this.$route.params.name
    },
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
    countries(){
      return this.$store.state.countries
    },
    country(){
      return this.$store.state.country
    },
  },
  watch:{
    selectedCountryId(){
      // console.log('selected country', this.selectedCountry, this.countries)
      this.selectedCountry = this.countries[this.selectedCountryId]
    },
    selectedCountry(){
      this.manualCountry()
    }
  },
  async created(){
    this.$store.state.countries = await axios.get(`https://product.yervip.com/api/v1/countries-ninja`).then(x=>x.data)
    // if(this.country) {
    //   this.selectedCountryId = this.countries.findIndex(x=>x.id == this.country.id)
    // }
  },
}
</script>

<style>
.flagBtn {
  height: 80px !important;
}
</style>